import { formValueSelector } from 'redux-form';
export const isSelected = (name, form) => state => formValueSelector(form)(state, `${name}.value.value`) === 'true';
//# sourceMappingURL=selection.js.map